import { useContext } from 'react'
import { useSelector } from 'react-redux'

import {
  useForm, useLatestEntity, useThunkDispatch,
} from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import defaultFormState, { requiredFields } from '@models/publicationCompatiblePagination'

import * as compatiblePaginationActions from '@redux/modules/publicationCompatiblePagination'

const createPublicationCompatiblePagination = (compatiblePaginationParams, dispatch, requestOptions) => {
  const { createPublicationCompatiblePagination: createFn } = compatiblePaginationActions
  return dispatch(createFn(compatiblePaginationParams, requestOptions))
}

const deletePublicationCompatiblePagination = (compatiblePagination, dispatch, requestOptions) => {
  const { deletePublicationCompatiblePagination: deleteFn } = compatiblePaginationActions
  return dispatch(deleteFn(compatiblePagination, requestOptions))
}

const addCompatiblePagination = (publicationCompatiblePagination, showCreatePublicationCompatiblePaginationModal) => (
  new Promise((resolve, reject) => {
    if (showCreatePublicationCompatiblePaginationModal){
      const payload = {
        publicationCompatiblePagination,
      }

      showCreatePublicationCompatiblePaginationModal(payload)

      resolve({ success: true, result: payload })
    }

    reject(new Error('showCreatePublicationCompatiblePaginationModal not defined in PageContext callbacks'))
  })
)

export function usePublicationCompatiblePaginationForm(compatiblePagination = {}, options = {}){
  const { validateOn } = options

  const compatiblePaginationForm = useForm(
    defaultFormState,
    { entity: compatiblePagination, requiredFields, validateOn },
    [compatiblePagination.id, compatiblePagination.cache_key],
  )

  return {
    ...compatiblePaginationForm,
  }
}

export function useRelations(publicationCompatiblePagination = {}){
  const { compatible_publication_id, publication_id } = publicationCompatiblePagination

  const publications = useSelector(reduxState => reduxState.entities.publications)

  const publication = publications[publication_id] || {}
  const compatiblePublication = publications[compatible_publication_id] || {}

  return {
    compatiblePublication,
    publication,
  }
}

function usePublicationCompatiblePagination(initEntity = {}){
  const { entity: publicationCompatiblePagination } = useLatestEntity(initEntity, 'publicationCompatiblePaginations')

  const dispatch = useThunkDispatch()

  const { callbacks } = useContext(PageContext)
  const { showCreatePublicationCompatiblePaginationModal } = callbacks || {}

  const {
    compatiblePublication,
    publication,
  } = useRelations(publicationCompatiblePagination)

  const { creating } = useSelector(reduxState => reduxState.publicationCompatiblePaginations)

  return {
    callbacks: {
      addCompatiblePagination: () => (
        addCompatiblePagination(publicationCompatiblePagination, showCreatePublicationCompatiblePaginationModal)
      ),
      createPublicationCompatiblePagination: (entityParams, requestOptions) => (
        createPublicationCompatiblePagination(entityParams, dispatch, requestOptions)
      ),
      deletePublicationCompatiblePagination: requestOptions => (
        deletePublicationCompatiblePagination(publicationCompatiblePagination, dispatch, requestOptions)
      ),
    },
    compatiblePublication,
    creating,
    publication,
    publicationCompatiblePagination,
  }
}

export default usePublicationCompatiblePagination
